import 'jquery'
import 'waypoints/lib/jquery.waypoints'
import './common'
import './experience/apply'

import '../public/iconfont/iconfont.css'
import '../public/css/animate.css'
import '../public/css/style.css'
import '../public/css/common.css'



// WEBPACK FOOTER //
// ./src/pc/js/lfdj.js